module.exports = __webpack_public_path__ + "static/media/IMG-7.ba14edf3.jpg";